import React from 'react'
import COLORS from '../../../styles/colors'

const defaultSize = {
  width: 30,
  height: 36,
}

const WashingMachine = ({ style = {}, color = COLORS.brand.primary }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    style={{ ...defaultSize, ...style }}
    viewBox='0 0 29.445 35.334'
  >
    <g fill={color}>
      <path d='M26.5,0H2.945A2.948,2.948,0,0,0,0,2.945V31.211a1.767,1.767,0,0,0,1.767,1.767v1.767a.589.589,0,0,0,.589.589H27.089a.589.589,0,0,0,.589-.589V32.978a1.767,1.767,0,0,0,1.767-1.767V2.945A2.948,2.948,0,0,0,26.5,0ZM2.945,1.178H26.5a1.767,1.767,0,0,1,1.767,1.767V7.067H1.178V2.945A1.767,1.767,0,0,1,2.945,1.178ZM26.5,34.156H2.945V32.978H26.5ZM27.678,31.8H1.767a.589.589,0,0,1-.589-.589V8.244H28.267V31.211a.589.589,0,0,1-.589.589Zm0,0' />
      <path
        d='M34.722,37.666h7.067a.589.589,0,0,0,.589-.589V34.722a.589.589,0,0,0-.589-.589H34.722a.589.589,0,0,0-.589.589v2.356A.589.589,0,0,0,34.722,37.666Zm.589-2.356H41.2v1.178H35.311Zm0,0'
        transform='translate(-31.777 -31.777)'
      />
      <path
        d='M172.435,37.666a1.767,1.767,0,1,0-1.767-1.767A1.767,1.767,0,0,0,172.435,37.666Zm0-2.356a.589.589,0,1,1-.589.589A.589.589,0,0,1,172.435,35.31Zm0,0'
        transform='translate(-158.89 -31.777)'
      />
      <path
        d='M240.7,37.666a1.767,1.767,0,1,0-1.767-1.767A1.767,1.767,0,0,0,240.7,37.666Zm0-2.356a.589.589,0,1,1-.589.589A.589.589,0,0,1,240.7,35.31Zm0,0'
        transform='translate(-222.444 -31.777)'
      />
      <path
        d='M307.788,52.377h1.178a.589.589,0,0,0,0-1.178h-1.178a.589.589,0,1,0,0,1.178Zm0,0'
        transform='translate(-285.999 -47.666)'
      />
      <path
        d='M358.988,52.377h1.178a.589.589,0,1,0,0-1.178h-1.178a.589.589,0,1,0,0,1.178Zm0,0'
        transform='translate(-333.665 -47.666)'
      />
      <path
        d='M86.223,153.6a9.422,9.422,0,1,0,9.422,9.422A9.422,9.422,0,0,0,86.223,153.6Zm0,17.667a8.245,8.245,0,1,1,8.245-8.245A8.245,8.245,0,0,1,86.223,171.269Zm0,0'
        transform='translate(-71.501 -143.002)'
      />
      <path
        d='M110.054,179.2a7.648,7.648,0,0,0-7.08,10.558c0,.012,0,.024,0,.036s.016.023.022.037a7.65,7.65,0,0,0,14.44-1,.227.227,0,0,0,.008-.03,7.626,7.626,0,0,0-7.394-9.606Zm0,1.178a6.463,6.463,0,0,1,6.321,7.879,9.091,9.091,0,0,0-.9.353,5.343,5.343,0,0,1-2.473.6,3.978,3.978,0,0,1-2.092-.53,5.144,5.144,0,0,0-2.619-.648,15.47,15.47,0,0,0-4.391.824,6.471,6.471,0,0,1,6.157-8.48Zm0,12.956a6.483,6.483,0,0,1-5.691-3.387,14.031,14.031,0,0,1,3.924-.736,3.979,3.979,0,0,1,2.092.53,5.143,5.143,0,0,0,2.619.648,6.354,6.354,0,0,0,2.852-.659,6.478,6.478,0,0,1-5.8,3.6Zm0,0'
        transform='translate(-95.331 -166.832)'
      />
    </g>
  </svg>
)

export default WashingMachine
